export default function() {
    var _53api = $53.createApi();
    _53api.push('cmd', 'kfclient');
    _53api.push('type', 'popup');
    _53api.query();
}